import RoutesMap from "../../route_control/RouteControl"
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
    UserLogin
} from "../../pages/user"
import VendorProfile from "../../pages/vendor/VendorProfile"
import Home from "../../pages/website/Home"
import PrivacyPolicy from "../../pages/website/PrivacyPolicy"
import TermsConditions from "../../pages/website/TermsConditions"
import ReturnRefundPolicy from "../../pages/website/ReturnRefundPolicy"

export const AuthRouteImport = {
    RoutesMap,
    useNavigate,
    Home,
    PrivacyPolicy,
    TermsConditions,
    ReturnRefundPolicy,
    Swal,
    UserLogin,
    VendorProfile,
}